import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateInspectionJobStateMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
  state: Types.Scalars['String']['input'];
}>;


export type UpdateInspectionJobStateMutation = { __typename?: 'mutation_root', update_inspection_jobs_by_pk?: { __typename?: 'inspection_jobs', id: any, state: string, updated_at?: any | null } | null };


export const UpdateInspectionJobStateDocument = gql`
    mutation updateInspectionJobState($id: uuid!, $state: String!) {
  update_inspection_jobs_by_pk(pk_columns: {id: $id}, _set: {state: $state}) {
    id
    state
    updated_at
  }
}
    `;
export type UpdateInspectionJobStateMutationFn = Apollo.MutationFunction<UpdateInspectionJobStateMutation, UpdateInspectionJobStateMutationVariables>;

/**
 * __useUpdateInspectionJobStateMutation__
 *
 * To run a mutation, you first call `useUpdateInspectionJobStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInspectionJobStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInspectionJobStateMutation, { data, loading, error }] = useUpdateInspectionJobStateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useUpdateInspectionJobStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInspectionJobStateMutation, UpdateInspectionJobStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInspectionJobStateMutation, UpdateInspectionJobStateMutationVariables>(UpdateInspectionJobStateDocument, options);
      }
export type UpdateInspectionJobStateMutationHookResult = ReturnType<typeof useUpdateInspectionJobStateMutation>;
export type UpdateInspectionJobStateMutationResult = Apollo.MutationResult<UpdateInspectionJobStateMutation>;
export type UpdateInspectionJobStateMutationOptions = Apollo.BaseMutationOptions<UpdateInspectionJobStateMutation, UpdateInspectionJobStateMutationVariables>;